import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ExternalLinkIcon } from 'lucide-react';
import ContactMe from '../Components/contact-me/contactme.component';

function Now() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="w-8 h-8 rounded-full border-2 border-gray-200 border-t-gray-900 animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white text-gray-900">
      <main className="container py-20">
        <Link
          to="/"
          className="flex items-center gap-1.5 text-sm text-gray-600 hover:text-black hover:underline mb-12"
        >
          <ArrowLeftIcon className="w-4 h-4" /> Back
        </Link>

        <h1 className="text-3xl font-bold tracking-tight mb-10">What I'm working on</h1>

        <section className="mb-12">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-2">
            Nasdaq Verafin
          </h2>
          <p className="text-gray-800 leading-relaxed max-w-2xl">
            Senior Software Engineer, Toronto. Building anti-fraud and AML infrastructure for
            cross-border payments.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-2">
            Code RAG
          </h2>
          <div className="max-w-2xl aspect-video mb-3">
            <iframe
              className="w-full h-full"
              src="https://www.youtube-nocookie.com/embed/AeT0IalZlSc"
              title="Code RAG demo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>
          <p className="text-gray-800 leading-relaxed max-w-2xl mb-3">
            A hybrid RAG pipeline for code search — AST-based chunking, dual vector + keyword
            retrieval fused by RRF, cross-encoder re-ranking, and grounded answers where every
            claim cites its exact source file, function, and line.
          </p>
          <a
            href="https://github.com/sourav15102/RAG"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm underline hover:text-black"
          >
            View on GitHub <ExternalLinkIcon className="w-3.5 h-3.5" />
          </a>
        </section>
      </main>

      <ContactMe />
    </div>
  );
}

export default Now;
